import React from 'react'
import Stepper, { Step, StepLabel } from 'material-ui/Stepper'
import Grid from 'material-ui/Grid'
import compose from 'lodash/fp/compose'
import { withHandlers, branch, renderComponent, mapProps } from 'recompose'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import withNewOrganization from '../withNewOrganization'

const Wizard = compose(
  branch(props => props.activeStep === 1,
    renderComponent((props) => (
      <Grid container>
        <Grid item xs={12}>
          <Typography>
            Welcome to EZ Repair Shop. We need you to answer a few questions in order to complete your profile.
          </Typography>
        </Grid>
      </Grid>
    ))
  ),
  branch(props => props.activeStep === 2,
    renderComponent(({ values, handleChange }) => (
      <Grid container>
        <Grid item xs={12}>
          <Typography>
            What is the name of your organization?
          </Typography>
          <TextField
            id="name"
            label="Organization Name"
            value={values.name}
            onChange={e => handleChange('name', e.target.value)}
            margin="normal"
            required
          />
        </Grid>
      </Grid>
    ))
  ),
  branch(props => props.activeStep === 3,
    renderComponent(() => (
      <Grid container>
        <Grid item xs={12}>
          <Typography>
            Thanks! That's all we needed to know for now.
          </Typography>
        </Grid>
      </Grid>
    ))
  )
)(() => <div>Not Found</div>)

export const NewOrganizationPage = ({ activeStep, handleNext, handleBack, ...rest }) =>
  <React.Fragment>
    <Wizard activeStep={activeStep} {...rest} />
    <Stepper activeStep={activeStep - 1} alternativeLabel>
      <Step>
        <StepLabel>Welcome</StepLabel>
      </Step>
      <Step>
        <StepLabel>Set up your organization</StepLabel>
      </Step>
      <Step>
        <StepLabel>Finish up</StepLabel>
      </Step>
    </Stepper>
    <Button onClick={handleBack}>Back</Button>
    <Button variant="raised" color="primary" onClick={handleNext}>Next</Button>
  </React.Fragment>

export default compose(
  mapProps(ownProps => ({
    activeStep: Number(ownProps.match.params.activeStep),
    history: ownProps.history,
    path: ownProps.match.path
  })),
  withNewOrganization,
  withHandlers({
    handleNext: ({ history, activeStep, path, saveNewOrganization, values }) => () => {
      const nextStep = Math.min(activeStep + 1, 3)
      if (activeStep === 2) {
        saveNewOrganization(values).then(() => {
          history.push(path.replace(':activeStep', nextStep))
        }).catch(() => console.error('failed to save organization'))
      } else {
        history.push(path.replace(':activeStep', nextStep))
      }
    },
    handleBack: ({ history, activeStep, path }) => () => {
      const prevStep = Math.max(activeStep - 1, 1)
      history.push(path.replace(':activeStep', prevStep))
    }
  })
)(NewOrganizationPage)


// WEBPACK FOOTER //
// ./src/modules/organizations/containers/NewOrganizationPage.js